<template>
<div>
    <div class="media media-dashboard">
        <div class="media-body">
            <div class="row row-sm mg-b-20">
                <div class="col-7">
                    <Firms />
                </div>
                <div class="col-5">
                    <BasicInfo />
                </div>
            </div>
            <div class="row row-sm mg-b-20">
                <div class="col-7">
                    <div class='row'>
                      <div class="col-6">
                        <Contributions />
                      </div>
                      <div class="col-6">
                        <Insurance />
                      </div>
                    </div>
                    <div class='row'>
                      <Pension />
                    </div>
                </div>
                <div class="col-5">
                    <MemberAge />
                </div>
            </div>
            <div class="row row-sm mg-b-20">
              <Investments />
            </div>
        </div>
    </div>
  </div>          
</template>
<script>
export default {
  name: 'BODashboard',
  components: {
    Firms : ()=>import('./bodashboard/Firms.vue'),
    BasicInfo : ()=>import('./bodashboard/BasicInfo.vue'),
    MemberAge : ()=>import('./bodashboard/MemberAge.vue'),
    Contributions : ()=>import('./bodashboard/Contributions.vue'),
    Insurance : ()=>import('./bodashboard/Insurance.vue'),
    Pension : ()=>import('./bodashboard/Pension.vue'),
    Investments: ()=>import('./bodashboard/Investments.vue'),
  },
}
</script>